/**
 * Placeholders for SoftwareApplication JSON-LD.
 * Pass overrides to `buildSoftwareApplicationSchema()` from structuredData.js
 * or via `<SoftwareApplicationJsonLd overrides={{ description: '...' }} />`.
 */
import { SITE_NAME } from './site';

export const SOFTWARE_APPLICATION_PLACEHOLDERS = {
  /** Application / product name */
  name: SITE_NAME,

  /** Target platforms — placeholders until App Store / Play listings ship */
  operatingSystem: 'iOS (placeholder), Android (placeholder)',

  /** Google-friendly category label (tune to match Search Console / Play / App Store) */
  applicationCategory: 'HealthAndFitness',

  /**
   * Product summary for crawlers — mentions AI-driven meal context and habits as requested.
   * Replace with final positioning when copy is locked.
   */
  description:
    'Notrack is a digital coach and health app for a Simple Diet Plan India: AI-guided daily structure and habits for Indian home food—roti, rice, dal, eggs, paneer, and chicken—without manually logging every calorie. Coming to iOS and Android.',
};
